/* eslint-disable no-undef */
import { getVersion } from '@/assets/js/native'
import { post } from '@/assets/js/json'
import mui from '@/assets/js/mui/mui'

export function check () {
  post('/api/member/index/hot/update').then((res) => {
    if (res.data.success) {
      let version = res.data.data.version
      let url = res.data.data.url
      getVersion().then((curVersion) => {
        if (Number(version) > Number(curVersion)) {
          downWgt(url)
        }
      })
    }
  })
}

function downWgt (url) {
  console.log("执行了")
  console.log(1+ +'更新'+ 1)
  // plus.nativeUI.showWaiting('正在更新中...')
  plus.downloader.createDownload(url, {filename: '_doc/update/'}, function (d, status) {
    if (status === 200) {
      console.log("下载成功")
      installWgt(d.filename) // 安装wgt包
    } else {
      console.log("下载失败")
      // plus.nativeUI.alert('下载更新文件失败！')
    }
    // plus.nativeUI.closeWaiting()
  }).start()
}
// 下载最新版本	
export function JX_download (url) {
  let a = 0;
  mui("#demo1").progressbar({progress:a}).show();
  //创建下载管理对象
  let SX_down= plus.downloader.createDownload(url,{}, function ( d, status ) {	
  // 下载完成
  if ( status == 200 ) { 
    plus.nativeUI.closeWaiting();
    //下载成功后的回调函数
      plus.nativeUI.toast( "下载成功，准备安装" + d.filename );
        plus.runtime.install(
          d.filename,
          {},
          function(){
            plus.nativeUI.toast('安装成功');
            plus.runtime.restart();
          },
          function(e){
            plus.nativeUI.toast(d.filename+'安装失败');
            alert(JSON.stringify(e))

          }
        );
      } else {
            alert( "下载失败 " + status ); 
      }  
    });

    // SX_down.start();
    //开始下载任务
    //plus.notification.setNotification("新版下载", "开始下载"); //插件调用
    SX_down.start();
    SX_down.addEventListener("statechanged", function(task, status) { 
      console.log("task.state--->" + task.state);
      switch(task.state) {
        case 1: // 开始
          console.log('开始');
          break;
        case 2: //已连接到服务器
          console.log('已连接到服务器');
          break;
        case 3: // 已接收到数据
          let current = parseInt(100 * task.downloadedSize / task.totalSize);
          console.log(current);
          mui("#demo1").progressbar().setProgress(current)
          document.getElementById("down").innerHTML = current+"%"
          break;
        case 4: // 下载完成 
          console.log('下载完成 ');
          //plus.notification.compProgressNotification("下载完成"); //插件调用
          /*plus.runtime.install(task.filename, {}, function() {
            //成功安装回调，执行重启app操作
            plus.runtime.restart();
          }, function(DOMException) {
            console.log(JSON.stringify(DOMException));
            // mui.toast("安装失败");
            alert("安装失败")
          });
          break;*/
      }
    });
}
export function downWgts (url) {
  console.log("执行了")
  console.log(1+ +'更新'+ 1)
  // plus.nativeUI.showWaiting('正在更新中...')
  plus.downloader.createDownload(url, {filename: '_doc/update/'}, function (d, status) {
    if (status === 200) {
      console.log("下载成功")
      installWgt(d.filename) // 安装wgt包
    } else {
      console.log("下载失败")
      // plus.nativeUI.alert('下载更新文件失败！')
    }
    // plus.nativeUI.closeWaiting()
  }).start()
}

// 更新应用资源
function installWgt (path) {
  // plus.nativeUI.showWaiting('正在安装更新成功...')
  plus.runtime.install(path, {}, function () {
    // plus.nativeUI.closeWaiting()
    plus.nativeUI.confirm('更新完成,是否重启App?', function (e) {
      if (e.index === 1) {
        plus.runtime.restart()
      }
    }, '提示', ['取消', '确定'])
  }, function (e) {
    // plus.nativeUI.closeWaiting()
    // console.log('安装更新文件失败！')
    // plus.nativeUI.alert('安装更新文件失败！')
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/checkUpdate.js